import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Link,
  Typography,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { routes } from "schemas/routes";

interface IProps {
  open: boolean;
  handleClose: () => void;
  searchQuery: string;
}

export default function CompletedDialog({
  open,
  handleClose,
  searchQuery,
}: IProps) {
  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>
        <Typography variant="h4">Emails Successfully Scheduled!</Typography>
      </DialogTitle>
      <DialogContent sx={{ mt: 1 }}>
        <Typography paragraph>
          You've successfully scheduled emails to local brands to pitch to based
          on your search: <strong>{searchQuery}</strong>
        </Typography>
        <Typography paragraph>
          Check the{" "}
          <strong>
            <Link
              component={RouterLink}
              to={`/${routes.inbox}`}
              underline="hover"
            >
              inbox page
            </Link>
          </strong>{" "}
          to see your scheduled emails and review the stats of this campaign on
          the{" "}
          <strong>
            <Link
              component={RouterLink}
              to={`/${routes.campaignView}`}
              underline="hover"
            >
              campaigns page
            </Link>
          </strong>
          .
        </Typography>

        <Typography paragraph>
          Ready to pitch to more brands? Close this dialog and start a new
          search whenever you're ready.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button color="secondary" onClick={handleClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
